// ScrollToTop.js - Scrolls to top on route navigation
// TODO: Consider adding smooth scroll option for specific transitions

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    console.log('[DEBUG ScrollToTop] Navigated to:', pathname);
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
